import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { finalize, map, Observable, of, tap } from 'rxjs';
import { VendorService } from '../services/vendor-service';
import { RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmployeeService } from '../services/employee-service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-leaverequest',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    RouterModule,
    MatDialogModule,
    MatSpinner,
    MatPaginatorModule,
    MatTooltipModule
  ],
  templateUrl: './leaverequest.component.html',
  styleUrl: './leaverequest.component.css'
})
export class LeaverequestComponent {
constructor(private employeeService: EmployeeService, private dialog: MatDialog) { }
  displayedColumns: string[] = [
    'slno',
    'id',  
    'leave_type',
    'leave_category',   
    'start_date',
    'end_date',
    'number_of_days',
    'approval_status', 
    'reason',
    'created_on'
    // 'updated_on'
  ];
  isLoading = false;
  leaveRequests$!: Observable<any[]>;
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.getOutstandingReport();
  }

  getOutstandingReport() {
    this.isLoading = true;
    this.leaveRequests$ = this.employeeService.getLeaveStatus().pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }
}
